import { getToken, isSupported } from 'firebase/messaging'

export const getFCMToken = async () => {
  console.log('Registering service worker for notifications')
  const isMessagingSupported = await isSupported()
  console.log('isMessagingSupported', isMessagingSupported)
  const registration = await navigator.serviceWorker
    .register('/firebase-messaging-module-sw.js', {
      scope: '/firebase-cloud-messaging-push-scope',
      type: 'module',
      updateViaCache: 'imports',
    })
    .catch(e => {
      console.error('FAILED TO REGISTER SERVICE WORKER', e)
      throw e
    })

  // Import messaging only when needed (browser-side)
  const { messaging, publicVapidKey } = await import('api/Firebase/firebase-messaging')

  if (isMessagingSupported && messaging && registration) {
    try {
      const FCMToken = await getToken(messaging, {
        serviceWorkerRegistration: registration,
        vapidKey: publicVapidKey,
      })
      console.log('FCM token obtained', FCMToken)
      return FCMToken
    } catch (e) {
      console.log('FAILED TO getToken', e)
      throw new Error('Messaging is not supported')
    }
  }

  console.log('Failed to register service worker')
  throw new Error('Messaging is not supported')
}
